/* eslint-disable array-callback-return */
/**
|--------------------------------------------------
| Array or Object (Handle Response)
|--------------------------------------------------
*/
export const checkArrayObject = (passed) => {
  if (Array.isArray(passed)) {
    return passed;
  } else if (passed instanceof Object) {
    let ObjToArra = [];
    ObjToArra.push(passed);
    return ObjToArra;
  } else {
    return passed;
  }
};
export const getC127AList = (list) => {
  let newList = [];
  list.forEach((item) => {
    let objVo = {};
    objVo = item;
    objVo.value = item.value;
    objVo.label = item.description;
    newList.push(objVo);
  });
  return newList;
};

/* Sort By Doctor Priority*/
export const sortAscendPriority = (list) => {
  return list.sort((a, b) => {
    return (a.firstName > b.firstName) - (a.firstName < b.firstName);
  });
};

export const sortByDoctorName = (list) => {
  return sortAscendPriority(list);
};
export const formatDate = (date) => {
  if (date) {
    const dateString = date.toDateString(),
      year = dateString.slice(11, 16),
      month = dateString.slice(4, 7),
      day = dateString.slice(8, 10),
      formattedDate = day + "-" + month + "-" + year;
    return formattedDate;
  }
};

/**
  |--------------------------------------------------
  | City List for Select
  |--------------------------------------------------
  */
export const getCitySelectList = (list) => {
  let newList = [],
    emptyVo = {};
  emptyVo.value = "";
  emptyVo.label = "";
  newList.push(emptyVo);

  list.map((item) => {
    let objVo = {};
    objVo = item;
    objVo.value = item.cityCode;
    objVo.label = item.cityDesc;
    newList.push(objVo);
  });
  return newList;
};
/**
  |--------------------------------------------------
  | GetLanguage List
  |--------------------------------------------------
  */
export const getLanguageSelectList = (list) => {
  let newList = [],
    emptyVo = {};
  emptyVo.value = "";
  emptyVo.label = "";
  newList.push(emptyVo);

  list.map((item) => {
    let objVo = {};
    objVo = item;
    objVo.value = item.value;
    objVo.label = item.description;
    newList.push(objVo);
  });
  return newList;
};
/**
  |--------------------------------------------------
  | Village List for Select
  |--------------------------------------------------
  */
export const getVillageSelectList = (list) => {
  let newList = [],
    emptyVo = {};
  emptyVo.value = "";
  emptyVo.label = "";
  newList.push(emptyVo);

  list.map((item) => {
    let objVo = {};
    objVo = item;
    objVo.value = item.villageDesc;
    objVo.label = item.villageDesc + "-" + item.talukDesc;
    newList.push(objVo);
  });
  return newList;
};

/**
    |--------------------------------------------------
    | Taluk List for Select
    |--------------------------------------------------
    */
export const getTalukSelectList = (list) => {
  let newList = [],
    emptyVo = {};
  emptyVo.value = "";
  emptyVo.label = "";
  newList.push(emptyVo);

  list.map((item) => {
    let objVo = {};
    objVo = item;
    objVo.value = item.talukDesc;
    objVo.label = item.talukDesc;
    newList.push(objVo);
  });
  return newList;
};

/**
    |--------------------------------------------------
    | City List for Select
    |--------------------------------------------------
    */

/**
    |--------------------------------------------------
    | State List for Select
    |--------------------------------------------------
    */
export const getStateSelectList = (list) => {
  let newList = [],
    emptyVo = {};
  emptyVo.value = "";
  emptyVo.label = "";
  newList.push(emptyVo);

  list.map((item) => {
    let objVo = {};
    objVo = item;
    objVo.value = item.stateCode;
    objVo.label = item.stateDesc;
    newList.push(objVo);
  });
  return newList;
};
/**
    |--------------------------------------------------
    | OccupationList List for Select
    |--------------------------------------------------
    */
export const getOccupationSelectList = (list) => {
  let newList = [],
    emptyVo = {};
  emptyVo.value = "";
  emptyVo.label = "";
  newList.push(emptyVo);
  list.map((item) => {
    let objVo = {};
    objVo = item;
    objVo.value = item.value;
    objVo.label = item.description;
    newList.push(objVo);
  });
  return newList;
};
/**
    |--------------------------------------------------
    | ContactList List for Select
    |--------------------------------------------------
    */
export const getContactSelectList = (list) => {
  let newList = [],
    emptyVo = {};
  emptyVo.value = "";
  emptyVo.label = "";
  newList.push(emptyVo);
  list.map((item) => {
    let objVo = {};
    objVo = item;
    objVo.value = item.transNo;
    objVo.label = item.contactName;
    if (item.phone && item.phoneNo != null) {
      objVo.label = objVo.label + "-" + item.phoneNo;
    }
    newList.push(objVo);
  });
  return newList;
};
export const getMonthFormat = (month) => {
  switch (month.toUpperCase()) {
    case "JAN":
      return "1";
    case "FEB":
      return "2";
    case "MAR":
      return "3";
    case "APR":
      return "4";
    case "MAY":
      return "5";
    case "JUN":
      return "6";
    case "JUL":
      return "7";
    case "AUG":
      return "8";
    case "SEP":
      return "9";
    case "OCT":
      return "10";
    case "NOV":
      return "11";
    case "DEC":
      return "12";
    default:
      return "1";
  }
};
/**
|--------------------------------------------------
| Check empty or undefined
|--------------------------------------------------
*/
export const checkEmpty = (item) => {
  if (item === undefined || item === null || item === "") {
    return true;
  }
  return false;
};

export const calculateAgeUsingDOB = (date, serverDate) => {
  let selDate = "",
    curDate = "",
    year = "",
    mon = "",
    day = "";
  year = date.slice(11);
  mon = date.slice(4, 7);
  day = date.slice(8, 10);
  mon = getMonthFormat(mon) - 1;

  selDate = new Date(year, mon, day);

  if (!checkEmpty(serverDate)) {
    curDate = new Date(serverDate);
  } else {
    curDate = new Date();
  }
  var diff = curDate.getTime() - selDate.getTime();
  let calcAge = Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
  return calcAge;
};

/**
  |--------------------------------------------------
  | Phone Code List for Select
  |--------------------------------------------------
  */
export const getPhoneCodeList = (list) => {
  let returnList = [];
  list.map((item) => {
    if (!checkEmpty(item.shortCode_2)) {
      let Vo = {};
      Vo.value = item.shortCode_2;
      Vo.label = item.phoneCode + " - " + item.countryName;
      returnList.push(Vo);
    }
  });

  return returnList;
};

/** Query params from hash route or search, e.g. #/MainDashBoard/?key=1&alpha=2 */
export const parseHashQueryParams = () => {
  const result = {};
  const mergeParams = (queryString) => {
    if (!queryString) return;
    const params = new URLSearchParams(queryString.split("#")[0]);
    params.forEach((value, key) => {
      result[key] = value;
    });
  };

  const hash = window.location.hash || "";
  const hashQ = hash.indexOf("?");
  if (hashQ !== -1) {
    mergeParams(hash.slice(hashQ + 1));
  }
  if (!Object.keys(result).length && window.location.search) {
    mergeParams(window.location.search.slice(1));
  }
  return result;
};

export const readStoredJson = (key, fallback = null) => {
  try {
    const raw = localStorage.getItem(key);
    if (raw == null || raw === "") return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

export const writeStoredJson = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
};
